<template>
	<div>
		<div class="set_indexBox" v-if="$route.path == '/setting'">
			<div class="set_tit">Setting</div>
			<div class="setting_optionsBox" v-if="isPro && isAccountingPlatformActivated">
				<span class="options_msg">Link to Accounting Platform</span>
				<span v-if='!xeroFlag && !blueFlag && !load' class="option_unlink1r" @click="connectToAccounting()">
					<span class="link-to-btn">Connect to</span>
				</span>
				<!-- <span v-if='!xeroFlag && !blueFlag && !load' class="option_unlink1r" @click="testXero()">
					<span class="link-to-btn">bind</span>
				</span> -->
				<span v-if='xeroFlag && !blueFlag && !load' class="option_link1"
					@click="linkDio = true, linkType = 1">Connected to {{ xeroName }}</span>
				<span v-if='!xeroFlag && blueFlag && !load' class="option_link_blue" @click="alterAsk"></span>
				<!-- <span class="option_link1" @click="xeroHasMoreDummy = true">Connected to</span> -->
			</div>
			<div class="setting_optionsBox" :style="`cursor: auto !important`">
				<span class="options_msg">Link to Scheduling Platform</span>
				<!-- <span v-if="!deputyFlag&&!load" class="option_unlink2" @click="linkSelDio =true"></span> -->
				<span v-if="!deputyFlag && !tandaFlag && !ehFlag && !load" class="option_unlink2r" @click="openScheduling()">
					<div class="link-to-btn">Connect to</div>
				</span>
				<span v-if="deputyFlag && !load" class="option_link2" style="cursor: pointer" @click="openConnectedPlatform(2, true)"></span>
				<span v-if="tandaFlag && !load" class="option_link4" style="cursor: pointer" @click="openConnectedPlatform(4, true)"></span>
				<span v-if="ehFlag && !load" class="option_link_eh" style="cursor: pointer" @click="openConnectedPlatform(15, true)"></span>
			</div>
			<div class="setting_optionsBox">
				<span class="options_msg">Link to Revenue Platform</span>
				<!--<span
				style="color: #2CCA73;"
				class="optionsItem_msg newLink-box"
				:class="{'nolink':!doshiFlag}">{{doshiFlag?'connect':'disconnect'}}</span>
				<i class="el-icon-arrow-right myset_icon" style="margin-left:0"></i>-->
				<span class="option_unlink3r" v-if="!doshiiFlag && !kseriesFlag && !oseriesFlag && !bindHandLFlag && !tevalisFlag && !idealposCsvFlag && !redcatFlag && !squareFlag && !imposCsvFlag && !bepozCsvFlag && !swiftPosFlag && !oolioFlag && !load" @click="connectToRevenue()">
					<div class="link-to-btn">Connect to</div>
				</span>

				<span class="option_link3" v-if="doshiiFlag && !load" @click="openConnectedPlatform(3)"></span>
				<span class="option_link_ks" v-if="kseriesFlag && !load" @click="openConnectedPlatform(5, true)"></span>
				<span class="option_link_os" v-if="oseriesFlag && !load" @click="openConnectedPlatform(6, true)"></span>
				<span class="option_link_handl" v-if="bindHandLFlag && !load" @click="openConnectedPlatform(7)"></span>
				<span class="option_link_tevalis" v-if="tevalisFlag && !load" @click="openConnectedPlatform(8)"></span>
				<span class="option_link_redcat" v-if="redcatFlag && !load" @click="openConnectedPlatform(9)"></span>
        	
        		<span class="option_link_idealpos" v-if="idealposCsvFlag && !load" @click="openConnectedPlatform(10)"></span>
				<span class="option_link_square" v-if="squareFlag && !load" @click="openConnectedPlatform(11, true)"></span>
				<span class="option_link_impos" v-if="imposCsvFlag && !load" @click="openConnectedPlatform(12)"></span>	
				<span class="option_link_bepoz" v-if="bepozCsvFlag && !load" @click="openConnectedPlatform(13)"></span>	
				<span class="option_link_swiftpos" v-if="swiftPosFlag && !load" @click="openConnectedPlatform(14)"></span>
				<span class="option_link_oolio" v-if="oolioFlag && !load" @click="openConnectedPlatform(16)"></span>
			</div>
			<div class="setting_optionsBox" @click="toUrl(1)">
				<span class="options_msg">Set Venue Information</span>
				<i class="el-icon-arrow-right myset_icon"></i>
			</div>
			<div class="setting_optionsBox" @click="automatedReport = true">
				<span class="options_msg">Set Automated Report</span>
				<i class="el-icon-arrow-right myset_icon"></i>
			</div>
			<div v-if="isDisableCashup" class="setting_optionsBox" @click="cashupSetting = true">
				<span class="options_msg">Cash-Up Setting</span>
				<i class="el-icon-arrow-right myset_icon"></i>
			</div>
			<div class="setting_optionsBox" @click="eodSetting = true">
				<span class="options_msg">EOD Settings</span>
				<i class="el-icon-arrow-right myset_icon"></i>
			</div>
			<template v-if="!isRentDisable">
				<div v-if="isPro" class="setting_optionsBox" @click="toUrl(2)">
					<span class="options_msg">Set Rent</span>
					<i class="el-icon-arrow-right myset_icon"></i>
				</div>
			</template>
			<div v-if="isBudgetingActivated" class="setting_optionsBox" @click="toUrl(10)">
				<span class="options_msg">Set Budgeting Tool</span>
				<i class="el-icon-arrow-right myset_icon"></i>
			</div>
			<div v-if="isPro" class="setting_optionsBox" @click="toUrl(4)">
				<span class="options_msg">Set Profit Target</span>
				<i class="el-icon-arrow-right myset_icon"></i>
			</div>
			<div class="setting_optionsBox" @click="isOpenLabourTarget = true">
				<span class="options_msg">Set Labour Target</span>
				<i class="el-icon-arrow-right myset_icon"></i>
			</div>
			<div v-if="isPro" class="setting_optionsBox" @click="toUrl(3)">
				<span class="options_msg">Revenue Stream</span>
				<i class="el-icon-arrow-right myset_icon"></i>
			</div>
			<div class="setting_optionsBox" @click="toUrl(6)" v-if="isPro && setFlag">
				<span class="options_msg">Manual Stocktakes COGs</span>
				<i class="el-icon-arrow-right myset_icon"></i>
			</div>
			<div class="setting_optionsBox" @click="toUrl(7)" v-if="isPro && showProfitLoss">
				<span class="options_msg">Set Profit & Loss</span>
				<i class="el-icon-arrow-right myset_icon"></i>
			</div>
			<div v-if="!isHidePosBrand" class="setting_optionsBox" @click="toUrl(8)">
				<span class="options_msg">Set POS Brand</span>
				<span class="optionsItem_msg">{{ posInfo.posBrand ? posInfo.posBrand : '' }}</span>
				<i class="el-icon-arrow-right myset_icon" style="margin-left:0"></i>
			</div>
			<!-- <div class="setting_optionsBox" @click="toUrl(9)" v-if="venueType === '2'"> -->
			<div v-if="isPro" class="setting_optionsBox" @click="toUrl(9)">
				<span class="options_msg">{{ pinType == 2 ? `Change PIN` : 'Set PIN' }}</span>
				<i class="el-icon-arrow-right myset_icon"></i>
			</div>
		</div>
		<div v-else>
			<router-view></router-view>
		</div>

		<!-- 3.22 新增 -->
		<xero :visibility="xeroVisibility" @close="xeroVisibility = false" @open-category-list="xeroRecall"></xero>

		<xerobindpop :visibility="xeroHasMore" @close="xeroHasMore = false" :defaultExpanded="defaultExpanded"
			:defaultData="defaultData"></xerobindpop>

		<!-- <xerobindpopdummy :visibility="xeroHasMoreDummy" @close="xeroHasMoreDummy = false"
		:defaultExpanded="dummyDefaultExpanded" :defaultData="dummyDefaultData" /> -->

		<!-- 弹框-->
		<el-dialog title="" :visible.sync="linkDio" :modal-append-to-body="false" :show-close='false' class="delEmployDio"
			:close-on-click-modal='false' width="1000px" center>
			<div class="linkDio-tit">
				Please select from the below options
			</div>
			<span slot="footer" class="dialog-footer">
				<!-- <el-button style="width:220px" @click="linkDio = false" class="cardCanBtn">Cancel</el-button>
                <el-button style="width:220px;" @click="linkSelDio =true" class="cardCanBtn">Unlink</el-button>
                <el-button style="width:220px" @click="linkUrl" class="cardConBtn">Re-link</el-button> -->
				<el-button style="width:220px;margin-bottom:30px;" @click="linkDio = false"
					class="cardCanBtn">Cancel</el-button>

				<el-button v-if="!isLoadingUnlinking" style="width:220px;margin-bottom:30px;" @click="unlink" class="cardCanBtn"
				:class="{ 'cardCanBtn2': linkType === 3 || linkType == 6 || linkType == 7 || linkType == 8 || linkType == 9 || linkType == 10 || linkType == 11 || linkType == 12 || linkType == 13}">Unlink</el-button>
				<el-button v-if="isLoadingUnlinking" style="width:220px;margin-bottom:30px;" class="cardCanBtn cursor-disable"
				:class="{ 'cardCanBtn2': linkType === 3 || linkType == 6 || linkType == 7 || linkType == 8 || linkType == 9 || linkType == 10 || linkType == 11 || linkType == 12 || linkType == 13}"><i class="el-icon-loading"></i></el-button>

				<el-button style="width:220px;margin-bottom:30px;" @click="linkUrl" class="cardConBtn"
					v-if="linkType === 1 || linkType === 2 || linkType === 4|| linkType === 5">Re-link</el-button>
			</span>
			<modal-message-dialog :isLoading="isLoadingUnlinking" :isDoneLoading="isDoneUnlinking" :label="messageLabel" :subLabel="messageSubLabel" @hide-message="doneLoading()"></modal-message-dialog>
		</el-dialog>

		<el-dialog title="" :visible.sync="linkSelDio" :modal-append-to-body="false" :show-close='false'
			class="delEmployDio modal-full-height" :close-on-click-modal='false' width="840px" center>
			<div class="linkDio-tit" style="text-align:left;">
				Found that this account has multiple physical addresses.
			</div>
			<div class="newMessage">Please select the roster of the physical address you want to obtain.</div>

			<div class="search-container">
				<el-input v-model="searchVenue" class="peiso-input-w-prefix font-16" clearable placeholder="Search">
					<template #prefix>
            <svg width="25" height="25" viewBox="0 0 25 25" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path d="M20.7292 21.8491L13.8802 15.0002C13.3594 15.4516 12.7521 15.8031 12.0584 16.0548C11.3646 16.3066 10.6264 16.4325 9.84375 16.4325C7.96594 16.4325 6.37669 15.7814 5.07602 14.4793C3.77534 13.1772 3.125 11.6061 3.125 9.76579C3.125 7.92551 3.77604 6.35433 5.07812 5.05225C6.38021 3.75016 7.95573 3.09912 9.80469 3.09912C11.6536 3.09912 13.2248 3.75016 14.5182 5.05225C15.8116 6.35433 16.4583 7.92681 16.4583 9.76969C16.4583 10.5136 16.3368 11.2328 16.0937 11.9272C15.8507 12.6217 15.4861 13.2727 15 13.8804L21.875 20.7033L20.7292 21.8491ZM9.81771 14.87C11.2283 14.87 12.4273 14.3708 13.4147 13.3726C14.4021 12.3743 14.8958 11.172 14.8958 9.76579C14.8958 8.35954 14.4021 7.15728 13.4147 6.15902C12.4273 5.16075 11.2283 4.66162 9.81771 4.66162C8.39266 4.66162 7.18135 5.16075 6.1838 6.15902C5.18627 7.15728 4.6875 8.35954 4.6875 9.76579C4.6875 11.172 5.18627 12.3743 6.1838 13.3726C7.18135 14.3708 8.39266 14.87 9.81771 14.87Z" fill="currentColor"/>
            </svg>
					</template>
				</el-input>
			</div>

			<div v-if="newSelLists.length > 0" class="venuelist-container">
				<div class="newSelect" v-for="(item, i) in newSelLists" :key="i" @click="chooseVenue(item)">
					{{ item.companyName }}
					<i class="el-icon-arrow-right myNewSel_icon"></i>
				</div>
			</div>
			<div v-else class="venuelist-container-nodata">
				<h4>No Data</h4>
			</div>

		</el-dialog>

		<el-dialog width="840px" :show-close='false' class="delEmployDio" :close-on-click-modal='false'
			:visible.sync="innerSelVisible">
			<div v-if="!isHideAreaList">
				<div class="linkDio-tit" style="text-align:left;">Please select area</div>
				<div class="newMessage" style="margin-bottom:50px">Multiple choice</div>

				<div class="area-list-container">
					<div class="box-check1 clear" v-for="(item, index) in checkOptions"
						@click="item.checked = !item.checked" :key="index" :class="{ 'box-checked1': item.checked }">
						{{ item.OperationalUnitName }}</div>
				</div>
			</div>

			<div v-if="selectFrom == 'tanda' && isNextSuperAnuation" class="tanda-anuation-container">
				<div class="title">
					Before you proceed, Please add superannuation for Tanda.
				</div>
				<div class="super-annuation-container d-flex flex-column align-items-center gap-16">
					<div class="annuation-wrapper w-100 d-flex align-items-center justify-content-between gap-10">
						<div>Add-on (%):</div>
						<el-input v-model="tandaSA" type="number" suffix-icon="%" min="0" class="peiso-input-default"></el-input>
					</div>
				</div>
			</div>

			<span slot="footer" class="new_dioFooter">
				<el-button style="width:220px;" @click="innerSelVisible = false, checkList = [], venueval = ''"
					class="cardCanBtn">Back
				</el-button>

				<template v-if="selectFrom == 'deputy'">
					<el-button style="width:220px;" @click="confirmBind" class="cardConBtn">
						Continue <i v-if="confirmBinding" class="el-icon-loading"></i>
					</el-button>
				</template>

				<template v-if="selectFrom == 'tanda'">
					<el-button v-if="!isNextSuperAnuation" style="width:220px;margin:0 0 0 50px"
						@click="setSuperAnuation" class="cardConBtn">
						Next
					</el-button>
					<el-button v-if="isNextSuperAnuation" style="width:220px;margin:0 0 0 50px" @click="confirmBind"
						class="cardConBtn">
						Continue <i v-if="confirmBinding" class="el-icon-loading"></i>
					</el-button>
				</template>
			</span>
		</el-dialog>

		<!-- 弹框-->
		<el-dialog title="" :visible.sync="linkSuccessDio" :modal-append-to-body="false" :show-close='false'
			class="delEmployDio" :close-on-click-modal='false' width="660px" center>
			<div class="success_icon"></div>
			<div class="delMsg-tit">
				Xero account has been successfully linked!
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="linkSuccessDio = false" class="cardConBtn" style="margin-left:0">Confirm</el-button>
			</span>
		</el-dialog>
		<!-- 弹框-->
		<el-dialog title="" :visible.sync="linkSuccessDio1" :modal-append-to-body="false" :show-close='false'
			class="delEmployDio" :close-on-click-modal='false' width="660px" center>
			<div class="success_icon"></div>
			<div class="delMsg-tit">
				{{ selectFrom === 'deputy' ? 'Deputy' : 'Tanda' }} account has been successfully linked!
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="linkSuccessDio1 = false" class="cardConBtn" style="margin-left:0">Confirm</el-button>
			</span>
		</el-dialog>
		<!-- 弹框-->
		<el-dialog title="" :visible.sync="linkFailDio" :modal-append-to-body="false" :show-close='false'
			class="delEmployDio" :close-on-click-modal='false' width="660px" center>
			<div class="fail_icon"></div>
			<div class="delMsg-tit">
				Xero account link failed. Please try again.
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="linkFailDio = false" class="cardConBtn" style="margin-left:0">Confirm</el-button>
			</span>
		</el-dialog>
		<el-dialog title="" :visible.sync="linkFailDio1" :modal-append-to-body="false" :show-close='false'
			class="delEmployDio" :close-on-click-modal='false' width="660px" center>
			<div class="fail_icon"></div>
			<div class="delMsg-tit">
				Deputy account link failed. Please try again.
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="linkFailDio1 = false" class="cardConBtn" style="margin-left:0">Confirm</el-button>
			</span>
		</el-dialog>

		<!-- 1.23 新增 -->
		<pinDiolog v-if="pinVisibility" @closeDiolog='pinVisibility = false' @confirmPin='confirmPin' :pinType='pinType'
			:pinVisibility='pinVisibility' />

		<linkOtherPlatformDiolog :linkOtherPlatformVisibility='linkOtherPlatformVisibility'
			@confirmDelDoshi='confirmDelDoshi' @close='linkOtherPlatformVisibility = false' />

		<choose-pos-dio v-if="choosePosVisibility" @closeDiolog='choosePosVisibility = false' @confirmPos='confirmPos'
			:choosePosVisibility='choosePosVisibility' :posId='posId' />

		<pin-dialog :visible="visible" @receive="receiveEvents" />

		<el-dialog :title="showAccountingSelect ? 'Select the Accounting Platform you want to link to' :
			showSchedulingSelect ? 'Select the Scheduling Platform you want to link to' :
			showRevenueSelect ? 'Select the Revenue Platform you want to link to' : ''"
			:visible="showAccountingSelect || showSchedulingSelect || showRevenueSelect" :modal-append-to-body="false"
			:show-close="false" class="delsmsDio_box title-left" :close-on-click-modal="false" width="840px" center>
			<div class="select-list" v-if="showAccountingSelect">
				<div class="select-item" v-for="(item, index) in accountingList" :key="item.class"
					@click="selectItem(index, 'accountingList')" :class="{ 'selected-item': item.checked }">
					<div class="logo" :class="item.class"></div>
					{{ item.title }}
				</div>
			</div>
			<div class="foot_box" v-if="showAccountingSelect">
				<el-button @click="showAccountingSelect = false" class="cardCanBtn"
					style="margin-left: 0">Cancel</el-button>
				<el-button class="cardCanBtn cardCanBtn2" @click="confirmSelect('accountingList')">Confirm</el-button>
			</div>

			<div class="select-list" v-if="showSchedulingSelect">
				<div class="select-item" v-for="(item, index) in schedulingList" :key="item.class" v-show="item.isDisplayed"
					:class="{ 'selected-item': item.checked }" @click="selectItem(index, 'schedulingList')">
					<div class="logo" :class="item.class"></div>
					{{ item.title }}
				</div>
			</div>
			<div class="foot_box" v-if="showSchedulingSelect">
				<el-button @click="showSchedulingSelect = false" class="cardCanBtn"
					style="margin-left: 0">Cancel</el-button>
				<el-button class="cardCanBtn cardCanBtn2" @click="confirmSelect('schedulingList')">Confirm</el-button>
			</div>
			<div class="select-list" v-if="showRevenueSelect">
				<div v-for="(item, i) in revenueList" :key="`revenue-${i}`">
					<div class="select-item" v-if="item.isDisplayed" :class="{ 'selected-item': item.checked }" @click="setSelectedRevenue(i)">
						<div class="logo" :class="item.class"></div>
						<h2>{{ item.title }}</h2>
						<p v-html="item.description"></p>
					</div>
				</div>
			</div>
			<div class="foot_box" v-if="showRevenueSelect">
				<el-button @click="showRevenueSelect = false" class="cardCanBtn" style="margin-left: 0">Cancel</el-button>
				<el-button v-if="!isLoadingRevenuePlatform" class="cardCanBtn cardCanBtn2" @click="revenueJumpTo()">Confirm</el-button>
				<el-button v-if="isLoadingRevenuePlatform" class="cardCanBtn cardCanBtn2 cursor-disable"><i class="el-icon-loading"></i></el-button>
			</div>

		</el-dialog>

		<el-dialog :visible.sync="cashupSetting" width="1200px" class="peiso-modal">
			<cashup-setting></cashup-setting>
		</el-dialog>

		<el-dialog :visible.sync="eodSetting" width="700px" class="peiso-modal">
			<eod-setting></eod-setting>
		</el-dialog>

		<modal-dialog :value="automatedReport" @close-modal="automatedReport = false" :maxAutomatedEmails="maxAutomatedEmails"></modal-dialog>

		<Bluesheets :showAsk="showBindBluesheetsAsk" :show="openBlueSheets" @closeShow="openBlueSheets = false"
			@closeShowAsk="showBindBluesheetsAsk = false" @done="blueFlag = true" @unBind="blueFlag = false" />

		<modal-business-location :open="businessLocationVisible" :business="businessData" :isPro="isPro" @close-modal="businessLocationVisible = false" @flagged="flaggedToLightSpeed('kseries')"></modal-business-location>
		<modal-loading :open="loadingVisibility" @close-modal="loadingVisibility = false" :loadingLabel="loadingLabel" :loadingPecentage="loadingPecentage"></modal-loading>
		<modal-labour-target width="400px" :open="isOpenLabourTarget" @close-modal="isOpenLabourTarget = false" @refresh="getStatus"></modal-labour-target>
		<modal-sites-location :open="siteLocationVisible" :sites="siteData" @close-modal="siteLocationVisible = false" @oseriesFlagged="flaggedToLightSpeed('oseries')" @redcatFlagged="completeRedcatBinding('redcat')" :isPro="isPro" :integrationType="integrationType"></modal-sites-location>
		
		<handl-configuration @close-modal="isOpenHandlConfiguration = false" @handl-bind="completeHandlBinding" :open="isOpenHandlConfiguration"></handl-configuration>

		<el-dialog :visible.sync="isOpenTevalisConfiguration"  :width="configurationStep == 1 ? '550px' : 'auto'" class="peiso-modal" :show-close="false" :modal-append-to-body="false" :close-on-click-modal='false' :close-on-press-escape="false">
			<tevalis-configuration @back="showRevenueSelect = true, isOpenTevalisConfiguration = false" :loading="isLoadingTevalis" @close="isOpenTevalisConfiguration = false" :configurationStep="configurationStep" :categories="categories" :sites="sites" :terminals="terminals" @siteChange="getTevalisCategories" @confirm="connectToTevalis" @complete="completeTevalisBinding"></tevalis-configuration>
		</el-dialog>

		<el-dialog :visible.sync="isOpenSwiftPosConfiguration"  width="550px" class="peiso-modal" :show-close="false" :modal-append-to-body="false" :close-on-click-modal='false' :close-on-press-escape="false">
			<swift-pos-configuration @back="isOpenSwiftPosConfiguration = false" @swiftpos-bind = "completeSwiftPosBinding"></swift-pos-configuration>
		</el-dialog>

		<el-dialog :visible.sync="isOpenRedcatConfiguration"  width="550px" class="peiso-modal" :show-close="false" :modal-append-to-body="false" :close-on-click-modal='false' :close-on-press-escape="false">
			<redcat-configuration @back="isOpenRedcatConfiguration = false" @redcat-bind = "redCatSiteSelectio"></redcat-configuration>
		</el-dialog>


    	<el-dialog :visible.sync="isOpenSquareConfiguration"  width="550px" class="peiso-modal" :show-close="false" :modal-append-to-body="false" :close-on-click-modal='false' :close-on-press-escape="false">
			<square-configuration @back="isOpenSquareConfiguration = false" :isLoadingSquare="isLoadingSquare" :code="squareCode" @square-bind = "completeSquareBinding"></square-configuration>
		</el-dialog>

		<el-dialog title="Oolio Configuration" :visible.sync="isOpenOolioConfiguration"  width="550px" class="peiso-modal" :show-close="false" :modal-append-to-body="false" :close-on-click-modal='false' :close-on-press-escape="false">
			<oolio-configuration @back="isOpenOolioConfiguration = false" :isLoading="isLoadingOolio" @oolio-bind="completeOolioBinding" :code="oolioCode"></oolio-configuration>
		</el-dialog>

    	<el-dialog :visible.sync="isOpenCsvUploadConfiguration" :title="csvTitle"  width="550px" class="peiso-modal" :show-close="false" :modal-append-to-body="false" :close-on-click-modal='false' :close-on-press-escape="false">
			<csv-upload-configuration @back="isOpenCsvUploadConfiguration = false" :selectedRevenuePlatform="selectedRevenuePlatform" @csv-bind="csvBinding"></csv-upload-configuration>
		</el-dialog>

	</div>
</template>

<script>
import api from '../../api/api';
import apiXero from '../../api/xero';
import pinDiolog from '../common/pinDiolog';
import linkOtherPlatformDiolog from '../common/linkOtherPlatformDiolog';
import ChoosePosDio from '../common/choosePosDio.vue';
import xero from '../common/pop.vue';
import xerobindpop from '../common/xerobindpop.vue';
import pinDialog from '../common/pin';
import bluesheets from "../common/bluesheets.vue";
import modalDialog from '../modal/dialog.vue';
import modalMessageDialog from '../modal/messageDialog.vue';
import modalBusinessLocation from '../modal/businessLocation.vue';
import modalSitesLocation from '../modal/siteRegisters.vue';
import modalLoading from '../modal/loading.vue';
import modalLabourTarget from '@/components/modal/labourTarget.vue'
import utils from '../../utils/utils';
import cashupSetting from '@/components/modal/cashupSetting.vue';
import eodSetting from '@/components/modal/eodSetting.vue';
import tevalisConfiguration from '@/components/modal/tevalisConfiguration.vue';
import redcatConfiguration from '@/components/modal/redcatConfiguration.vue';
import tevalisConfigurationStepTwo from '@/components/modal/tevalisConfigurationStepTwo.vue';
import SquareConfiguration from '../modal/squareConfiguration.vue';
import CsvUploadConfiguration from '../modal/csvUploadConfiguration.vue';
import handlConfiguration from '../modal/handlConfiguration.vue';
import swiftPosConfiguration from '../modal/swiftPosConfiguration.vue';
import oolioConfiguration from '../modal/oolioConfiguration.vue';
import { env } from '../../env';

// import xerobindpopdummy from '../common/xerobindpop.vue';

export default {
	components: { pinDiolog, linkOtherPlatformDiolog,
		ChoosePosDio,
		xero,
		pinDialog,
		xerobindpop,
		Bluesheets: bluesheets,
		modalDialog: modalDialog,
		modalBusinessLocation: modalBusinessLocation,
		modalLoading: modalLoading,
		modalSitesLocation: modalSitesLocation,
		modalMessageDialog: modalMessageDialog,
		modalLabourTarget: modalLabourTarget,
		cashupSetting: cashupSetting,
		tevalisConfiguration: tevalisConfiguration,
		tevalisConfigurationStepTwo: tevalisConfigurationStepTwo,
		redcatConfiguration: redcatConfiguration,
		eodSetting: eodSetting,
		SquareConfiguration,
    	CsvUploadConfiguration,
		handlConfiguration,
		swiftPosConfiguration,
		oolioConfiguration,
	},
	data() {
		return {
			isMaster: parseInt(sessionStorage.getItem('isMaster')),
			searchVenue: '',
			confirmBinding: false,

			showAccountingSelect: false,
			accountingList: [],

			showSchedulingSelect: false,
			schedulingList: [],

			showRevenueSelect: false,
			revenueList: [],

			venueType: sessionStorage.getItem('venueType'),

			xeroVisibility: false,
			xeroName: '',

			bindHandLFlag: false,

			newSelList: [],
			checkOptions: [],
			checkList: [],
			linkSelDio: false,
			innerSelVisible: false,
			venueval: '',

			deputyFlag: false,
			tandaFlag: false,
			ehFlag: false,
			doshiiFlag: false,
			csvTitle: '',
      		idealposCsvFlag: false,
			imposCsvFlag: false,
			bepozCsvFlag: false,
			oolioFlag: false,
			xeroFlag: false,
			timer: null,
			timer2: null,
			timer3: null,
			timer4: null,
			timer5: null,
			load: false,
			linkDio: false,
			linkType: 1,
			linkSuccessDio: false,
			linkSuccessDio1: false,
			linkFailDio: false,
			linkFailDio1: false,
			setFlag: false,
			kseriesFlag: false,
			tevalisFlag: false,
			type_dio: 1,


			// 1.23 新增
			pinVisibility: false,
			linkOtherPlatformVisibility: false,
			choosePosVisibility: false,
			posInfo: {},
			pinType: window.sessionStorage.getItem('pinstatus') == 'true' ? 2 : 1, //  1为验证。2 修改
			//
			pageIndex: 0,
			doshiFlag: true,
			posId: '',

			pincodes: null,
			visible: false,

			selectFrom: '',

			showProfitLoss: false,

			xeroHasMore: false,
			defaultExpanded: [],
			defaultData: [],

			openBlueSheets: false,
			showBindBluesheetsAsk: false,
			blueFlag: false,
			automatedReport: false,
			isNextSuperAnuation: false,
			isHideAreaList: false,

			tandaSA: 11,
			isLoadingRevenuePlatform: false,
			businessLocationVisible: false,
			businessData: null,
			loadingVisibility: false,
			loadingLabel: '',
			loadingPecentage: 0,
			isDisableCashup: parseInt(process.env.IS_ENABLE_CASHUP),
			oseriesFlag: false,
			siteLocationVisible: false,
			siteData: [],
			kseriesBlid: null,
			isLoadingUnlinking: false,
			isDoneUnlinking: false,
			messageLabel: '',
			messageSubLabel: '',
			subVenueId: sessionStorage.getItem('subVenueId'),
			isOpenLabourTarget: false,
			isPro: false,
			isBudgetingActivated: false,
			isAccountingPlatformActivated: false,
			cashupSetting: false,
			eodSetting: false,
			isOpenTevalisConfiguration: false,
      		isOpenCsvUploadConfiguration: false,
			isOpenTevalisConfigurationStepTwo: false,
			isOpenRedcatConfiguration: false,
      		isOpenSquareConfiguration: false,
			isOpenOolioConfiguration: false,
			oolioCode: null,
			isLoadingOolio: false,
			isLoadingTevalis: false,
			configurationStep: 1,
			categories: [],
			sites: [],
			maxAutomatedEmails: null,
			integrationType: null,
			redcatFlag: false,
			squareFlag: false,
			swiftPosFlag: false,
			squareCode: null,
			isLoadingSquare: false,
			isType: '',
			isHidePosBrand: true,
			terminals: [],
			instance_type: process.env.INSTANCE_TYPE,
			isRentDisable: true,
			selectedRevenuePlatform: null,
			isOpenHandlConfiguration: false,
			isOpenSwiftPosConfiguration: false,
			isDashboardV2: sessionStorage.getItem('isDashboardV2') === 'true' ? true : false,
			isAllowedUnlinking: sessionStorage.getItem('isAllowedUnlinking') ? true : false,
		}
	},
	computed: {
		newSelLists () {
			let result = this.newSelList;

			if (this.newSelList.length > 0) {
				result = this.newSelList.filter((res) => {
					return res.companyName.toLowerCase().includes(this.searchVenue.toLowerCase())
				})
			}

      		return result
		}
	},
	created() {
		this.load = true
		this.getStatus()
	},
	methods: {
		isOpenModal() {
			console.log('t')
		},
		alterAsk() {
			this.showBindBluesheetsAsk = true
		},
		openScheduling() {
			var that = this
			// that.schedulingList.forEach((e, i) => {
			// 	e.checked = false
			// })
			that.showSchedulingSelect = true
			if (!this.schedulingList.length) {
				this.schedulingList = [
					{
						title: 'Deputy',
						class: 'deputy',
						checked: true,
						isDisplayed: true,
					},
					{
						title: 'Tanda',
						class: 'tanda',
						checked: false,
						// isDisplayed: this.isPro ? true : false,
						isDisplayed: true,
					}
				]
			}
		},
		selectItem(index, type) {
			var that = this
			if (type === 'schedulingList') {
				that.schedulingList.forEach((e, i) => {
					e.checked = index === i ? true : false
				})
			} else if (type === 'accountingList') {
				that.accountingList.forEach((e, i) => {
					e.checked = index === i ? true : false
				})
			}
		},
		confirmSelect(type) {
			var that = this
			if (type === 'schedulingList') {

				let current = that.schedulingList.find(e => {
					return e.checked
				})
				if (!current) {
					Utils.alert("", 'Please choose one', "error");
					return
				}
				that.showSchedulingSelect = false
				if (current.title === 'Deputy')
					that.jumpDeputy()
				else
					that.jumpTanda()
			} else if (type === 'accountingList') {
				let current = that.accountingList.find(e => {
					return e.checked
				})
				if (!current) {
					Utils.alert("", 'Please choose one', "error");
					return
				}
				that.showAccountingSelect = false
				if (current.title === 'Xero')
					that.jumpXero()
				// 8848
				else if (current.title === 'Bluesheets') {
					this.openBlueSheets = true
				}
			}
		},
		unbindScheduling() {
			// 判断一下是解绑哪一个
			this.showSchedulingAsk = true
		},

		receiveEvents(type) {
			this.visible = false
			if (type === 'confirm' && this.jump === 4) {
				this.$router.push({ path: '/target' })
			} else if (type === 'confirm' && this.jump === 7) {
				this.$router.push({ path: '/setProfitLoss' })
			}

		},
		unlinkDoshii() {
			var that = this
			api.unsubscribed({
				callback: (res) => {
					if (res.data.code === 0) {
						// that.linkDio = false
						that.doshiiFlag = false
					} else if (res.data.code == 8902) {
						sessionStorage.clear()
						that.$router.push('/login')
					} else {
						Utils.alert('', res.data.message, 'error')
					}
					this.isDoneUnlinking = true
					this.messageLabel = 'All done!'
					this.messageSubLabel = 'Successfully unlinked'
				}
			})
		},
		unlinkHandl() {
			api.unlinkHandl().then((res) => {
				if (res.data.code == 0) {
					this.bindHandLFlag = false
					sessionStorage.setItem('handlFlag', this.bindHandLFlag)
					this.linkDio = false
				} else {
					utils.alert('', res.data.message, 'error')
				}
				// console.log(res)
			}).catch((err) => {
				utils.alert('', err, 'error')
			})
		},
		jumpDoshii() {
			api.clickBindDoshii({
				callback: (res) => {
					if (res.data.code !== 0) {
						Utils.alert("", res.data.message, "error");
					}
					this.showRevenueSelect = false
					this.isLoadingRevenuePlatform = false
				},
			});
			window.open('https://dashboard.doshii.io/venues')
		},
		async unlink() { // 解绑
      // this.linkDio = false;
			this.isLoadingUnlinking = true
			this.isDoneUnlinking = false
			this.messageLabel = 'Unlinking'
			this.messageSubLabel = 'Please wait...'
			if (this.linkType == 1) { // xero
				api.unlinkXero('', res => {
					// this.linkDio = false
					if (res.data.code == 0) {
						this.xeroFlag = false
						window.sessionStorage.setItem('xeroFlag', false);
						utils.alert('', res.data.message, 'success')
					} else {
						utils.alert('', res.data.message, 'error')
					}
					this.isDoneUnlinking = true
					this.messageLabel = 'All done!'
					this.messageSubLabel = 'Successfully unlinked'
				})
			} else if (this.linkType == 2) {
				console.log('this.linkType: ', this.linkType);
				api.unlinkDeputy('', res => {
					// this.linkDio = false
					if (res.data.code == 0) {
						this.deputyFlag = false
						window.sessionStorage.setItem('deputyFlag', false);
						utils.alert('', res.data.message, 'success')
					} else {
						utils.alert('', res.data.message, 'error')
					}
					this.isDoneUnlinking = true
					this.messageLabel = 'All done!'
					this.messageSubLabel = 'Successfully unlinked'
				})
			} else if (this.linkType == 3) {
				this.unlinkDoshii()
			} else if (this.linkType == 4) {
				api.unlinkTanda('', res => {
					// this.linkDio = false
					if (res.data.code == 0) {
						this.tandaFlag = false
						window.sessionStorage.setItem('tandaFlag', false);
						utils.alert('', res.data.message, 'success')
					} else {
						utils.alert('', res.data.message, 'error')
					}
					this.isDoneUnlinking = true
					this.messageLabel = 'All done!'
					this.messageSubLabel = 'Successfully unlinked'
				})
			} else if (this.linkType == 5) {
				api.kseriesUnlink().then((res) => {
					// this.linkDio = false
					if (res.data.code == 0) {
						utils.alert2('', 'Unlinking successfully', 'success')
						localStorage.removeItem('blId')
						localStorage.removeItem('kseriesState')
						localStorage.removeItem('apiType')
						localStorage.removeItem('kseriesCode')
						this.kseriesFlag = false
					} else {
						utils.alert('', res.data.message, 'error')
					}
					this.isDoneUnlinking = true
					this.messageLabel = 'All done!'
					this.messageSubLabel = 'Successfully unlinked'
				})
			} else if (this.linkType == 6) {
				api.oseriesUnbind().then((res) => {
					this.linkDio = false
					if (res.data.code == 0) {
						utils.alert2('', 'Unbinding successfully', 'success')
						localStorage.removeItem('oseriesCode')
						localStorage.removeItem('oseriesState')
						localStorage.removeItem('apiType')
						this.oseriesFlag = false
					}
				})
			} else if (this.linkType == 7) {
				this.unlinkHandl()
			} else if (this.linkType == 8) {
				api.tevalisUnbind().then((res) => {
					this.isDoneUnlinking = true
					this.messageLabel = 'All done!'
					this.messageSubLabel = 'Tevalis successfully unlinked'
				})
			} else if (this.linkType == 9) {
				api.redcatUnbinding().then((res) => {
					this.isDoneUnlinking = true
					this.messageLabel = 'All done!'
					this.messageSubLabel = 'Redcat successfully unlinked'
				})
			} else if (this.linkType == 10) {
				try {
					const res = await api.csvUploadUnBinding('idealpos')
					this.isDoneUnlinking = true
					this.messageLabel = 'All done!'
					this.messageSubLabel = 'IdealPOS successfully unlinked'
				} catch (error) {
					if (error && error.response.data) {
						utils.alert2('', error.response.data.message, 'error')
					}
				}
			} else if (this.linkType == 11) {
				api.squareUnbinding().then((res) => {
					this.isDoneUnlinking = true
					this.messageLabel = 'All done!'
					this.messageSubLabel = 'Square successfully unlinked'
				})
			} else if (this.linkType == 12) {
				try {
					const res = await api.csvUploadUnBinding('impos')
					this.isDoneUnlinking = true
					this.messageLabel = 'All done!'
					this.messageSubLabel = 'Impos successfully unlinked'
				} catch (error) {
					if (error && error.response.data) {
						utils.alert2('', error.response.data.message, 'error')
					}
				}
			} else if (this.linkType == 13) {
				try {
					const res = await api.csvUploadUnBinding('bepoz')
					this.isDoneUnlinking = true
					this.messageLabel = 'All done!'
					this.messageSubLabel = 'Bepoz successfully unlinked'
				} catch (error) {
					if (error && error.response.data) {
						utils.alert2('', error.response.data.message, 'error')
					}
				}
			} else if (this.linkType == 14) {
				api.swiftPosUnbinding().then((res) => {
					this.isDoneUnlinking = true
					this.messageLabel = 'All done!'
					this.messageSubLabel = 'SwiftPOS successfully unlinked'
				})
			} else if (this.linkType == 15) {
				this.isDoneUnlinking = true
				this.messageLabel = 'Note:'
				this.messageSubLabel = 'EH successfully unlinked'
				api.keyPayUnbinding().then((res) => {
					this.isDoneUnlinking = true
					this.messageLabel = 'All done!'
					this.messageSubLabel = 'EH successfully unlinked'
				})
			} else if (this.linkType == 16) {
				try {
					const res = await api.csvUploadUnBinding('oolio')
					this.isDoneUnlinking = true
					this.messageLabel = 'All done!'
					this.messageSubLabel = 'Oolio successfully unlinked'
				} catch (error) {
					if (error && error.response.data) {
						utils.alert2('', error.response.data.message, 'error')
					}
				}
			}
		},
		linkUrl() { // 重新绑定
			this.linkDio = false
			if (this.linkType == 1) { // xero
				this.jumpXero()
				this.type_dio = 1
			} else if (this.linkType == 2) { // Deputy
				this.jumpDeputy()
				this.type_dio = 2
			} else if (this.linkType == 5) { // k series
				this.jumpLightSpeedKseries()
			} else {
				this.jumpTanda()
				this.type_dio = 4
			}
		},
		toUrl(key) {
			if (key == 1) {
				this.$router.push({ path: '/setInformation' })
			} else if (key == 2) {
				this.$router.push({ path: '/setRent' })
			} else if (key == 3) {
				this.$router.push({ path: '/stream' })
			} else if (key == 4) { // 1.23 验证pin
				// this.$router.push({path:'/target'})
				// this.pinType = 1
				// this.pinVisibility = true
				// this.pageIndex = 1
				this.jump = 4
				if (this.venueType === '2') {
					this.visible = true
				} else if (this.venueType === '1') {
					this.$router.push({ path: '/target' })
				}
			} else if (key == 5) {
				this.$router.push({ path: '/holidays' })
			} else if (key == 7) { // 1.23 验证pin

				this.jump = 7
				if (this.venueType === '2') {
					this.visible = true
				} else if (this.venueType === '1') {
					this.$router.push({ path: '/setProfitLoss' })
				}
				/*this.pinType = 1
				this.pinVisibility = true
				this.pageIndex = 2*/
				// this.$router.push({path:'/setProfitLoss'})
			} else if (key == 6) {
				this.$router.push({ path: '/manualStocktakesCOGs' })
			} else if (key == 8) { // pos
				this.choosePosVisibility = true
			} else if (key == 9) { // pin

				// this.pinType = 2
				this.pinVisibility = true
			} else if (key == 10){
				this.$router.push({ path: '/setBudgetingTool' })
			}
		},
		jumpXero() {
			localStorage.removeItem('xeroCode')
			// for sandbox
			let sandboxXero = "https://login.xero.com/identity/connect/authorize?response_type=code&client_id=20A39760C9914CFCA25A482C03598984&redirect_uri=https://sandbox-venue.peiso.com.au/login&scope=openid profile email  accounting.reports.read accounting.settings  offline_access&state=xero"
			// for online
			let prodXero = "https://login.xero.com/identity/connect/authorize?response_type=code&client_id=0965E05CF1364AF9994B5A2B95AD2E3A&redirect_uri=https://venue.peiso.com.au/login&scope=openid profile email  accounting.reports.read accounting.settings  offline_access&state=xero"

			window.open(
				process.env.XERO_URL,
				"_blank"
			);
			// 开始轮询
			clearInterval(this.timer)
			this.timer = setInterval(this.longpoll, 3000)
		},
		longpoll() {
			if (!localStorage.getItem('xeroCode')) {
				// console.log('还没有拿到xero的回调码')
			} else {
				clearInterval(this.timer)
				const xeroCode = localStorage.getItem('xeroCode')
				localStorage.removeItem('xeroCode')
				// 在这里传给后台
				api.sendXero({
					params: {
						code: xeroCode
					},
					callback: this.xeroCallback
				})
			}
		},
		xeroRecall(defaultData, defaultExpanded) {
			console.log(defaultData, defaultExpanded)
			this.defaultData = defaultData
			this.defaultExpanded = defaultExpanded
			this.xeroVisibility = false
			this.xeroHasMore = true
		},
		xeroCallback(res) {
			var that = this
			that.linkDio = false
			that.defaultExpanded = []
			that.defaultData = []
			if (res.data.code == 0) {
				this.linkSuccessDio = true
				window.sessionStorage.setItem('xeroFlag', true);
				//Utils.alert('', res.data.message, 'success')
				// 连接xero成功后, 判断有设置追踪类别就给他选
				// 没有设置追踪类别就那么弹出No tracking category has been set for this account Continue弹窗同时调用Save接口
				apiXero.getTrackingCategories({
					callback: (res) => {
						if (res.data.code == 0) {
							this.xeroFlag = true
							this.getStatus()
							if (res.data.data.length > 0) {
								res.data.data.forEach(item => {
									let children = []
									item.Options.forEach(i => {
										children.push({
											id: i.TrackingOptionID,
											label: i.Name,
											parent: item.TrackingCategoryID
										})
									})
									that.defaultData.push({
										id: item.TrackingCategoryID,
										label: item.Name,
										children: children
									})
									that.defaultExpanded.push(item.TrackingCategoryID)

									this.linkSuccessDio = false
									this.xeroHasMore = true
								})
							} else {
								this.xeroHasMore = true
								apiXero.saveTrackingCategories({
									params: { categoryList: [] },
									callback: (res) => {
										if (res.data.code == 0) {
											this.xeroFlag = true
											this.getStatus()
										} else {
											Utils.alert('', res.data.message, 'error')
										}
									}
								})
							}
						} else {
							Utils.alert('', res.data.message, 'error')
						}
					}
				})
			} else {
				this.linkFailDio = true
				//Utils.alert('', res.data.message, 'error')
			}
		},
		jumpDeputy() {
			localStorage.removeItem('deputyCode')
			// for sandbox
			let sandboxDeputy = "https://once.deputy.com/my/oauth/login?client_id=f65b88c2bf496c5a553567322d35e7e7f1ab5d03&redirect_uri=https://sandbox-venue.peiso.com.au/login&response_type=code&scope=longlife_refresh_token"

			// for online
			let prodDeputy = "https://once.deputy.com/my/oauth/login?client_id=64a567becdf815c8b223d69544c7385d24959f08&redirect_uri=https://venue.peiso.com.au/login&response_type=code&scope=longlife_refresh_token"

			if (process.env.IS_MAIN == '0') {
				window.open(`${process.env.MAIN_URI}login?instance_type=${process.env.INSTANCE_TYPE}`, "_blank")
			} else {
				localStorage.setItem('instance_type', process.env.INSTANCE_TYPE)
			}

			setTimeout(() => {
				window.open(
					process.env.DEPUTY_URL,
					"_blank"
				);
			}, 500);

			// 开始轮询
			// localStorage.setItem('deputyCode','sdsdasw121342342')
			clearInterval(this.timer2)
			this.timer2 = setInterval(this.longpoll2, 3000)
		},
		longpoll2() {
			if (!localStorage.getItem('deputyCode')) {
				// console.log('还没有拿到deputy的回调码')
			} else {
				const deputyCode = localStorage.getItem('deputyCode')
				localStorage.removeItem('deputyCode')
				// 在这里传给后台
				this.newSelList = []
				api.sendDeputy({
					params: {
						code: deputyCode
					},
					callback: this.deputyCallback
				})
			}
		},
		deputyCallback(res) {
			this.linkDio = false
			if (res.data.code == 0) {
				this.selectFrom = 'deputy'
				this.newSelList = res.data.data
				this.linkSelDio = true
			} else {
				Utils.alert('', res.data.message, 'error')
			}
		},
		jumpTanda() {
			this.showSchedulingAsk = false;
			localStorage.removeItem("tandaCode");
			// for sandbox
			let sandboxTanda = "https://my.tanda.co/api/oauth/authorize?client_id=7dfadd9bafc4c400f053309d718f2c9c712eb61feb3e9c1dd3e86d3108377ffa&redirect_uri=https%3A%2F%2Fsandbox-venue.peiso.com.au%2Flogin?type=tanda&response_type=code&scope=roster+timesheet+department+user+cost+settings+me+datastream"

			// for online
			let prodTanda = "https://my.tanda.co/api/oauth/authorize?client_id=c2dabdb414a28be50bbef6cfbe7109a96c38298279c88711749147373421038c&redirect_uri=https%3A%2F%2Fvenue.peiso.com.au%2Flogin?type=tanda&response_type=code&scope=roster+timesheet+department+user+cost+settings+me+datastream"
			window.open(
				process.env.TANDA_URL,
				"_blank"
			);


			// 开始轮询
			clearInterval(this.timer3);
			this.timer3 = setInterval(this.longpoll3, 3000);
			// localStorage.setItem("tandaCode", '00002ae87016424ebb95c5bd80d41da41bea8bcff0c440842309d78fe7ecce54')
		},
		longpoll3() {
			if (!localStorage.getItem("tandaCode")) {
				//console.log("还没有拿到tanda的回调码");
			} else {
				clearInterval(this.timer3);
				const tandaCode = localStorage.getItem("tandaCode");
				//console.log('tandaCode')
				//console.log(tandaCode)
				localStorage.removeItem("tandaCode");
				// 在这里传给后台
				this.newSelList = [];
				api.sendTanda({
					params: {
						code: tandaCode,
					},
					callback: this.tandaCallback,
				});
			}
		},
		tandaCallback(res) {
			if (res.data.code == 0) {
				this.selectFrom = 'tanda';
				this.newSelList = res.data.data;
				this.linkSelDio = true;
			} else if (res.data.code == 8902) {
				sessionStorage.clear();
				this.$router.push("/login");
			} else {
				Utils.alert("", res.data.message, "error");
				// this.linkFailDeputy = true
			}
		},
		jumpLightSpeedKseries() {
			const urlType = `${process.env.WEB_URL}/`
			api.getKseriesAuthorization({url: urlType}).then((res) => {
				localStorage.setItem('apiType', 'kseries')
				let url = res.data.data
				window.open(url, "_blank")


				clearInterval(this.timer4);
      			this.timer4 = setInterval(this.longPollLightSpeedKseries, 3000);
			}).catch((err) => {
				// utils.alert2('', err, 'error')
			})

		},
		jumpLightSpeedOseries() {
			let oseriesUrl = process.env.LIGHTSPEED_OSERIES
			window.open(oseriesUrl, '_blank')

			localStorage.setItem('apiType', 'oseries')

			this.timer5 = setInterval(this.longPollLightSpeedOseries, 3000)

		},
		longPollLightSpeedOseries() {
			if (!localStorage.getItem('oseriesCode')) {
				return
			}
			var data = {}
			data.code = localStorage.getItem('oseriesCode')
			data.state = localStorage.getItem('oseriesState')

			this.showRevenueSelect = false
			this.loadingVisibility = true
			this.loadingLabel = 'Authenticating...'
			this.loadingPecentage = 30

			api.oseriesBind(data).then((res) => {
				var result = res.data
				this.loadingLabel = 'Connecting to Lightspeed O-series...'
				setTimeout(() => {
					this.loadingPecentage = 80
					setTimeout(() => {
					this.loadingPecentage = 100
					this.siteLocationVisible = true
					this.loadingVisibility = false
					}, 500);
				}, 500);
				if (result.code == 0) {
				var result = res.data
				this.siteData = result.data
				} else if (result.code == 10000) {
				var data = [
					{
					id: 117946,
					name: 'Lucia',
					code: 'Lucia'
					}
				]
				this.siteData = data
				}
				else {
				Utils.alert("", res.data.message, "error");
				}
				clearInterval(this.timer5)
			})

		},
		longPollLightSpeedKseries() {

			if (!localStorage.getItem('kseriesCode')) {
				return
			}
			var data = {}
			data.code = localStorage.getItem('kseriesCode')
			data.state = localStorage.getItem('kseriesState')
			data.redirect_uri = `${process.env.WEB_URL}/`

			this.showRevenueSelect = false
			this.loadingVisibility = true
			this.loadingLabel = 'Authenticating...'
			this.loadingPecentage = 30

			api.kseriesHandShake(data).then((res) => {
				var result = res.data
				if (result.code == 0) {
					console.log(res)
					this.loadingLabel = 'Connecting to Lightspeed K-series...'
					this.loadingPecentage = 80
					api.kseriesBusinesses().then((res) => {
						this.businessData = res.data.data
						this.businessLocationVisible = true

						this.loadingLabel = 'Successfully connected, Opening businesses list...'
						this.loadingPecentage = 99
						setTimeout(() => {
							this.loadingVisibility = false
						}, 1000);
					})
					clearInterval(this.timer4)
				} else {
					// utils.alert2('', result.message, 'error')
				}
			})
		},

		tevalisRegistration(siteData) {
			setTimeout(() => {
				this.loadingVisibility = true
				this.loadingLabel = 'Authenticating...'
				this.loadingPecentage = 30
				setTimeout(() => {
					this.loadingLabel = 'Connecting to Lightspeed O-series...'
					this.loadingPecentage = 80
					setTimeout(() => {
					this.loadingPecentage = 100
					this.siteLocationVisible = true
					this.loadingVisibility = false
					}, 500);
					this.siteData = siteData
				}, 500);
			}, 500);
		},

		getBusinesses(data) {
			console.log(data)
			api.kseriesBusinesses({gAccessToken: data.access_token}).then((res) => {
				console.log(res.data)
			})
		},

		chooseVenue(val) {
			this.venueval = val;
			// 这里区分一下
			this.isHideAreaList = false
			if (this.selectFrom === 'deputy') {
				api.getDeputyOption({
					params: {
						companyId: val.companyId,
					},
					callback: (res) => {
						if (res.data.code == 0) {
							res.data.data.forEach((item) => {
								item.checked = false;
							});
							this.checkOptions = res.data.data;
							this.innerSelVisible = true;
						} else {
							Utils.alert("", res.data.message, "error");
						}
					},
				});
			} else {
				api.getTandaOption({
					params: {
						companyId: val.companyId,
					},
					callback: (res) => {
						if (res.data.code == 0) {
							this.checkOptions = res.data.data.map((item) => {
								item.checked = true

								return item
							})
							this.innerSelVisible = true;
							this.isNextSuperAnuation = false
						} else {
							Utils.alert("", res.data.message, "error");
						}
					},
				});

			}
		},
		setSuperAnuation() {
			if (this.selectFrom == 'tanda') {
				this.isHideAreaList = true
				this.isNextSuperAnuation = true
			}
		},
		confirmBind() {
			let temp = [];
			this.checkOptions.forEach((item) => {
				if (item.checked) {
					temp.push({
						Company: item.Company,
						CompanyName: item.CompanyName,
						Id: item.Id,
						LabelWithCompany: item.LabelWithCompany,
						OperationalUnitName: item.OperationalUnitName,
					});
				}
			});
			this.confirmBinding = true
			// 在这里区分一下
			if (this.selectFrom === 'deputy') {
				api.bindDeputyTrue({
					params: {
						companyId: this.venueval.companyId,
						companyName: this.venueval.companyName,
						operationalUnitInfoList: temp,
					},
					callback: (res) => {
						this.confirmBinding = false
						if (res.data.code == 0) {
							this.innerSelVisible = false
							this.linkSelDio = false
							this.linkDio = false
							this.linkSuccessDio1 = true
							this.deputyFlag = true
							this.checkList = []
							this.checkOptions = []
							// this.newSelList = []
							window.sessionStorage.setItem('deputyFlag', true);
						} else {
							this.linkFailDio1 = true
							Utils.alert2('', res.data.message, 'error')
						}
					},
				});
			} else {
				if (this.tandaSA == '' || !this.tandaSA) {
					Utils.alert('Please input Tanda super annuation.')
					return
				}
				api.bindTandaTrue({
					params: {
						companyId: this.venueval.companyId,
						companyName: this.venueval.companyName,
						operationalUnitInfoList: temp,
					},
					callback: (res) => {
						this.confirmBinding = false
						if (res.data.code == 0) {
							this.innerSelVisible = false
							this.linkSelDio = false
							this.linkDio = false
							this.linkSuccessDio1 = true
							this.tandaFlag = true
							this.checkList = []
							this.checkOptions = []
							// this.newSelList = []
							window.sessionStorage.setItem('tandaFlag', true);
						} else {
							this.linkFailDio1 = true
							Utils.alert2('', `error code ${res.data.code};error message ${res.data.message}`, 'error')
						}
					},
				});

				api.tandaSuperAnuation({
					params: {
						applySuperAnnuation: this.tandaSA ? true : false,
						superAnnuationRate: this.tandaSA
					},
					callback: (res) => {
						console.log(res.data)
					}
				})

				api.updateCost({
					params: this.tandaSA / 100,
					callback: (res) => {
						console.log('Update cost', res);
					},
				});
			}
		},
		async getStatus() {
			this.load = true
			api.progress('', res => {
				if (res.data.code == 0) {
					this.deputyFlag = res.data.data.deputyFlag
					this.tandaFlag = res.data.data.tandaFlag
					this.doshiiFlag = res.data.data.doshiiFlag
					this.xeroFlag = res.data.data.xeroFlag
					this.blueFlag = res.data.data.blueesheetFlag
					this.kseriesFlag = (res.data.data.kseriesBind || res.data.data.kseriesFlag)
					this.kseriesBlid = res.data.data.kseriesBlid
					this.oseriesFlag = res.data.data.oseriesFlag
					this.bindHandLFlag = res.data.data.handlFlag
					this.tevalisFlag = res.data.data.tevalisFlag
					this.redcatFlag = res.data.data.redcatFlag
          			this.squareFlag = res.data.data.squareFlag
					this.swiftPosFlag = res.data.data.swiftPosFlag

					this.isPro = (res.data.data.isPro == 1)

					this.idealposCsvFlag = res.data.data.idealposCsvFlag
					this.imposCsvFlag = res.data.data.imposCsvFlag
					this.bepozCsvFlag = res.data.data.bepozCsvFlag
					this.oolioFlag = res.data.data.oolioFlag
          			

					this.xeroVisibility = (res.data.data.trackingCategoriesFlag === false && res.data.data.xeroFlag === true) ? true : false

					this.xeroName = res.data.data.xeroTenantName === null || res.data.data.xeroTenantName === '' ? 'Xero' : res.data.data.xeroTenantName
					this.maxAutomatedEmails = res.data.data.maxAutomatedEmails ? res.data.data.maxAutomatedEmails : 5

					if (res.data.data.posInfo) {
						this.posInfo = res.data.data.posInfo
						this.posId = res.data.data.posInfo.posId
					}
					window.sessionStorage.setItem('deputyFlag', this.deputyFlag);
					window.sessionStorage.setItem('tandaFlag', this.tandaFlag);
					window.sessionStorage.setItem('xeroFlag', this.xeroFlag);
					window.sessionStorage.setItem('handlFlag', this.bindHandLFlag);
				} else {
					Utils.alert('', res.data.message, 'error')
				}
				this.load = false
			})

			if (this.isDashboardV2 && env.NAME != 'lucas') {
				const integrations = await api.fetchIntegrations();
				if (integrations && integrations.length > 0) {
					integrations.forEach(item => {
						if (item.type == 'keypay') {
							this.ehFlag = true;
						}
					});
				}
				
			}

		},
		getFlag() {
			api.getSetFlag('', res => {
				if (res.data.data === true) {
					this.setFlag = true
					this.showProfitLoss = true
				} else {
					// Utils.alert('', res.data.message, 'error')
					if (!res.data.data && this.$route.path === '/setProfitLoss')
						this.$router.push('/setting')
				}
			})
		},
		//1.23 new
		confirmPin(flag) { // 修改pin
			this.pinVisibility = false
			this.pinType = 2
			// if (!flag) return
			// switch (this.pageIndex) {
			// 	case 1:
			// 		this.$router.push({ path: '/target' })
			// 		break;
			// 	case 2:
			// 		this.$router.push({ path: '/setProfitLoss' })
			// 		break;
			// 	default:
			// 		break;
			// }
		},
		confirmPos(val) { // 修改pos
			this.getStatus()
			this.choosePosVisibility = false
		},
		confirmDelDoshi() { // 解绑doshi
			this.doshiFlag = false
		},

		setSelectedRevenue(idx) {
			this.revenueList = this.revenueList.map((n) => {
				n.checked = false
				return n
			})

			this.revenueList[idx].checked = true
		},

		revenueJumpTo() {
			this.isLoadingRevenuePlatform = true
			const rev = this.revenueList.find(n => n.checked)

			this.selectedRevenuePlatform = rev.abbr

			if (rev.abbr == 'Doshii') {
				this.jumpDoshii()
			} else if (rev.abbr == 'k-series') {
				this.jumpLightSpeedKseries()
				// this.businessLocationVisible = true
				// this.isLoadingRevenuePlatform = false
				// this.loadingVisibility = true
			} else if (rev.abbr == 'o-series') {
				localStorage.setItem('apiType', 'oseries')
				localStorage.removeItem('oseriesCode')
				localStorage.removeItem('oseriesState')
				this.integrationType = 'oseries'
				this.jumpLightSpeedOseries()
			} else if (rev.abbr == 'tevalis') {
				this.isOpenTevalisConfiguration = true
				this.showRevenueSelect = false
				this.isLoadingRevenuePlatform = false
				this.isLoadingTevalis = false
			} else if (rev.abbr == 'redcat') {
				this.integrationType = 'redcat'
				this.isOpenRedcatConfiguration = true
				this.isLoadingRevenuePlatform = false
			} else if (rev.abbr == 'square') {
        		this.jumpSquare();
			} else if (rev.abbr == 'idealpos') {
				this.isOpenCsvUploadConfiguration = true
				this.isLoadingRevenuePlatform = false
				this.csvTitle = 'IdealPOS Configuration'
			} else if (rev.abbr == 'impos') {
				this.isOpenCsvUploadConfiguration = true
				this.isLoadingRevenuePlatform = false
				this.csvTitle = 'Impos Configuration'
			} else if (rev.abbr == 'bepoz') {
				this.isOpenCsvUploadConfiguration = true
				this.isLoadingRevenuePlatform = false
				this.csvTitle = 'Bepoz Configuration'
			} else if (rev.abbr == 'handl') {
				this.isOpenHandlConfiguration = true
				this.isLoadingRevenuePlatform = false
			} else if (rev.abbr == 'swiftpos') {
		
				this.isOpenSwiftPosConfiguration = true
				this.isLoadingRevenuePlatform = false
			} else if (rev.abbr == 'oolio') {
				this.jumpOolio();
			}
		},

		jumpSquare () {
			window.open(process.env.SQUARE_URL, "_blank")

			clearInterval(this.timer)

			this.timer = setInterval(this.squareLongpoll, 3000)
		},

		jumpOolio() {
			window.open(process.env.OOLIO_URL, "_blank")
			clearInterval(this.timer)
			this.timer = setInterval(this.oolioLongpoll, 1000)
		},

		oolioLongpoll() {
			if (localStorage.getItem('oolioCode')) {
				clearInterval(this.timer)
				this.oolioCode = localStorage.getItem('oolioCode')
				this.integrationType = 'oolio'

				this.isOpenOolioConfiguration = true
				this.showRevenueSelect = false

				localStorage.removeItem('oolioCode')
			}
		},

		squareLongpoll() {
			if (localStorage.getItem('squareCode')) {
				clearInterval(this.timer)

				this.squareCode = localStorage.getItem('squareCode')
				this.integrationType = 'square'
				this.isOpenSquareConfiguration = true
				this.isLoadingRevenuePlatform = false
				this.showRevenueSelect = false;
				
				localStorage.removeItem('squareCode')
			}
		},

		flaggedToLightSpeed(flaggedType) {
			this.fristdisable = false
			this.kseriesBind = false
			this.oseriesFlag = false
			if (flaggedType == 'kseries') {
				this.kseriesBind = true
			} else if (flaggedType == 'oseries') {
				this.oseriesFlag = true
			}
		},

		doneLoading() {
			this.linkDio = false
			this.isDoneUnlinking = false
			location.reload()
		},

		connectToAccounting() {
			this.showAccountingSelect = true
			if (!this.accountingList.length) {
				this.accountingList = [
					{
						title: 'Xero',
						class: 'xero',
						checked: true ,
						isDisplayed: this.isPro ? true : false,
					},
					{
						title: 'Bluesheets',
						class: 'bluesheets',
						checked: false ,
						isDisplayed: this.isPro ? true : false,
					}
				]
			}
		},

		// testXero() {
		// 	this.xeroHasMore = true
		// 	this.defaultData = [
		// 		{
		// 			trackingCategoryID: '21312312323123',
		// 			label: 'test label',
		// 		}
		// 	]
		// 	var children = []
		// 	for (var i = 0; i <= 50; i++) {
		// 		children.push({
		// 			trackingCategoryID: '12344562131231',
		// 			id: i,
		// 			label: `Test xero ${i}`
		// 		})
		// 	}

		// 	this.defaultData[0].children = children
		// },

		connectToRevenue() {
			const isAllowedUnlinking = sessionStorage.getItem('isAllowedUnlinking') ? 1 : 0
			this.showRevenueSelect = true
			if (!this.revenueList.length) {
				this.revenueList = [
					{
						title: 'Bepoz',
						description: 'Please go to Bepoz configuration to complete the integration',
						class: 'bepoz',
						abbr: 'bepoz',
						checked: false,
						isDisplayed: this.instance_type == 'sandbox' && isAllowedUnlinking ? true : false,
					},
					{
						title: 'Doshii',
						description: 'Please go to the Doshii management background to initiate a connection<br />request to Peiso',
						class: 'doshii',
						abbr: 'Doshii',
						checked: false,
						isDisplayed: this.isPro && isAllowedUnlinking ? true : false,
					},
					{
						title: 'H&L',
						description: 'Please go to H&L configuration to complete the integration',
						class: 'handl',
						abbr: 'handl',
						checked: false,
						isDisplayed: isAllowedUnlinking ? true : false,
					},
					{
						title: 'IdealPOS',
						description: 'Please go to IdealPOS configuration to complete the integration',
						class: 'idealpos',
						abbr: 'idealpos',
						checked: false,
						isDisplayed: isAllowedUnlinking ? true : false,
					},
					{
						title: 'Impos',
						description: 'Please go to Impos configuration to complete the integration',
						class: 'impos',
						abbr: 'impos',
						checked: false,
						isDisplayed: isAllowedUnlinking ? true : false,
					},
					{
						title: 'Lightspeed Restaurant (K-Series)',
						description: 'Please go to the Lightspeed  management background to initiate a connection<br />request to Peiso',
						class: 'k-series',
						abbr: 'k-series',
						checked: false,
						isDisplayed: true,
					},
					{
						title: 'Lightspeed Restaurant (O-Series)',
						description: 'Please go to the Lightspeed  management background to initiate a connection<br />request to Peiso',
						class: 'o-series',
						abbr: 'o-series',
						checked: false,
						isDisplayed: true,
					},
					{
						title: 'Oolio',
						description: 'Please go to Oolio configuration to complete the integration',
						class: 'oolio',
						abbr: 'oolio',
						checked: false,
						isDisplayed: isAllowedUnlinking ? true : false,
					},
					{
						title: 'Redcat',
						description: 'Please go to Redcat configuration to complete the integration',
						class: 'redcat',
						abbr: 'redcat',
						checked: false,
						isDisplayed: isAllowedUnlinking ? true : false,
					},
					{
						title: 'Square',
						description: 'Please go to the Square management background to initiate a connection<br />request to Peiso',
						class: 'square',
						abbr: 'square',
						checked: false,
						isDisplayed: true,
					},
					{
						title: 'SwiftPOS',
						description: 'Please go to SwiftPOS configuration to complete the integration',
						class: 'swiftpos',
						abbr: 'swiftpos',
						checked: false,
						isDisplayed: this.instance_type == 'sandbox' && isAllowedUnlinking ? true : false,
					},
					{
						title: 'Tevalis',
						description: 'Please go to Tevalis configuration to complete the integration',
						class: 'tevalis',
						abbr: 'tevalis',
						checked: false,
						isDisplayed: isAllowedUnlinking ? true : false,
					}
				]
			}
		},
		getTevalisCategories(siteId) {
			api.tevalisCategories(siteId).then((category) => {

				if (category.data.code == 0) {
				this.categories = category.data.data
				this.configurationStep = 2
				} else {
				utils.alert2("", res.data.message, 'error')
				}
				console.log(this.configurationStep)
				this.isLoadingTevalis = false
			})
		},


		async connectToTevalis(data) {
			this.isLoadingTevalis = true

			api.tevalisBind(data).then(async (res) => {
				if (res.data.code == 0) {
					this.sites = res.data.data
					var terminals = await api.tevalisTerminals(this.sites[0].id)
					this.terminals = terminals.data.data
					api.tevalisCategories(this.sites[0].id).then((category) => {

						if (category.data.code == 0) {
							this.categories = category.data.data
							this.configurationStep = 2
						} else {
							utils.alert2("", res.data.message, 'error')
						}
						console.log(this.configurationStep)
						this.isLoadingTevalis = false
					})
				} else {
					utils.alert2("", res.data.message, 'error')
					this.isLoadingTevalis = false
				}
				// this.isOpenTevalisConfiguration = false
			}).catch((err) => {
				utils.alert2('', 'Connection failt in tevalis integration binding', 'error')
				this.isLoadingTevalis = false
				this.isOpenTevalisConfiguration = false
			})
			// setTimeout(() => {
			// }, 2000);
		},

		async completeSquareBinding (data) {
			this.isLoadingSquare = false
			this.isOpenSquareConfiguration = false
			this.getStatus();

			setTimeout(() => {
				window.location.reload();
			}, 1000);
		},

		completeOolioBinding(data) {
			this.isLoadingOolio = false
			this.isOpenOolioConfiguration = false
			this.getStatus();

			setTimeout(() => {
				window.location.reload();
			}, 1000);
		},

		async completeHandlBinding(data) {
			this.isLoadingHandl = false
			this.isOpenHandlConfiguration = false
			this.getStatus();

			setTimeout(() => {
				window.location.reload();
			}, 1000);
			
		},

		completeTevalisBinding(data) {
			this.isLoadingTevalis = true
			api.tevalisCompleteBinding(data).then((res) => {
				if (res.data.code == 0) {
					this.isLoadingTevalis = false
					this.isOpenTevalisConfiguration = false
					this.getStatus()
					utils.alert2("", 'Tevalis successfully connected.', 'success')
				} else {
					utils.alert2("", res.data.message, 'error')
				}
			})
		},

		csvBinding(value) {
			this.showRevenueSelect = false
			this.isOpenCsvUploadConfiguration = false;
			this.getStatus()
		},

		redCatSiteSelectio(isOpen, siteData) {
			this.siteLocationVisible = isOpen
			this.siteData = siteData
		},

		completeSwiftPosBinding(data) {
			this.isOpenSwiftPosConfiguration = false
			this.getStatus()
			setTimeout(() => {
				window.location.reload();
			}, 1000);
		},



		completeRedcatBinding(data) {
			this.showRevenueSelect = false
			this.getStatus()
		},

		openConnectedPlatform(linkType, enableUnlinking = false) {	
			const isAllowedUnlinking = sessionStorage.getItem('isAllowedUnlinking') ? 1 : 0
			if (!enableUnlinking && !isAllowedUnlinking) {
				return
			}
			
			this.linkDio = true
			this.linkType = linkType
		}

	},
	mounted() {
		this.xeroFlag = window.sessionStorage.getItem('xeroFlag');
		this.deputyFlag = window.sessionStorage.getItem('deputyFlag');

		this.getFlag();

		this.$root.$on('isPro', (isPro, other) => {
			this.isPro = isPro
			this.isBudgetingActivated = other.isBudgetingActivated
			this.isAccountingPlatformActivated = other.isAccountingPlatformActivated
		})
	},
	beforeDestroy() {
		clearInterval(this.timer)
		clearInterval(this.timer2)
	}
}
</script>

<style lang="scss">
@import '../../../static/scss/fonts/fonts.scss';
@import '../../../static/scss/colors.scss';

.box-check1 {
	word-break: break-word;
	box-sizing: border-box;
	padding: 14px 0 14px 46px;
	font-size: 20px;
	font-family: PingFangSC-Semibold, PingFang SC;
	font-weight: 600;
	color: var(--text-color);
	line-height: 32px;
	background-repeat: no-repeat;
	background-position: 10px center;
	background-size: 16px 16px;
	background-image: url('../../assets/p2.png');
	cursor: pointer;
}

.box-checked1 {
	background-image: url('../../assets/p1.png') !important;
}


.set_indexBox {
	width: 100%;

	.set_tit {
		height: 33px;
		font-size: 24px;
		font-weight: 600;
		color: var(--text-color);
		line-height: 33px;
		margin-bottom: 39px;
	}


	.setting_optionsBox {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 20px 30px;
		background: var(--background-color-3);
		//height: 70px;
		margin-bottom: 30px;
		cursor: pointer;

		.options_msg {
			//height: 28px;
			font-size: 20px;
			font-family: PingFang SC;
			font-weight: 600;
			color: var(--text-color);
			line-height: 28px;
		}

		.optionsItem_msg {
			margin-left: auto;
			margin-right: 15px;
			font-size: 16px;
			font-weight: 400;
			color: varr(--primary-color);
		}

		.option_unlink {
			margin-left: auto;
			height: 28px;
			font-size: 20px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: var(--text-color);
			line-height: 28px;
			text-decoration: underline;
			cursor: pointer;

			&::before {
				content: '';
				display: inline-block;
				width: 12px;
				height: 12px;
				background: var(--primary-color);
				border-radius: 6px;
				margin-right: 10px;
			}
		}

		.option_unlink1r {
			margin-left: auto;
			width: 222px;
			// height: 43px;
			// background: url('../../../static/img/xeo1.png');
			background-repeat: no-repeat;
			background-size: contain;
			background-position: right;
		}

		.option_link1 {
			min-width: 222px;
			margin-left: auto;
			// height: 43px;
			text-align: right;
			background-image: url('../../../static/img/p.png');
			background-repeat: no-repeat;
			background-size: 33px auto;
			background-position: 9px center;
			background-color: #0D83A9;
			border-radius: 3px;
			box-sizing: border-box;
			padding: 0 10px 0 60px;
			font-size: 14px;
			line-height: 43px;
			color: var(--text-color);;
		}

		.option_link_blue {
			margin-left: auto;
			width: 233px;
			height: 43px;
			background: url('../../assets/bluesheet2.png');
			background-repeat: no-repeat;
			background-size: auto 43px;
			background-position: right;
		}

		.option_unlink3r {
			margin-left: auto;
			width: 222px;
			// height: 43px;
			// background: url('../../../static/img/bb.png');
			text-align: right;
			background-repeat: no-repeat;
			background-size: contain;
			background-position: right;
		}

		.option_link3 {
			margin-left: auto;
			width: 222px;
			height: 43px;
			background: url('../../../static/img/dd2.png');
			background-repeat: no-repeat;
			background-size: contain;
			background-position: right;
		}

		.option_link_ks {
			margin-left: auto;
			width: 222px;
			height: 43px;
			background: url('../../assets/ctks.png');
			background-repeat: no-repeat;
			background-size: contain;
			background-position: right;
		}

		.option_link_os {
			margin-left: auto;
			width: 222px;
			height: 43px;
			background: url('../../assets/ctos.jpg');
			background-repeat: no-repeat;
			background-size: contain;
			background-position: right;
		}

		.option_link_handl {
			margin-left: auto;
			width: 222px;
			height: 43px;
			background-image: url("../../assets/cthl.png");
			background-repeat: no-repeat;
			background-size: contain;
			background-position: right;
			border-radius: 5px;
		}

		.option_link_tevalis {

			margin-left: auto;
			width: 222px;
			height: 43px;
			background-image: url("../../assets/cttevalis.png");
			background-repeat: no-repeat;
			background-size: contain;
			background-position: right;
			border-radius: 5px;
		}

		.option_link_redcat {

			margin-left: auto;
			width: 222px;
			height: 43px;
			background-image: url("../../assets/ctredcat.png");
			background-repeat: no-repeat;
			background-size: contain;
			background-position: right;
			border-radius: 5px;
		}

		.option_link_square {
			margin-left: auto;
			width: 222px;
			height: 43px;
			background-image: url("../../assets/square.png");
			background-repeat: no-repeat;
			background-size: contain;
			background-position: right;
			border-radius: 5px;
		}
    	.option_link_idealpos {

			margin-left: auto;
			width: 222px;
			height: 43px;
			background-image: url("../../assets/ctcsv-idealpos.png");
			background-repeat: no-repeat;
			background-size: contain;
			background-position: right;
			border-radius: 5px;
		}
		.option_link_oolio {

			margin-left: auto;
			width: 222px;
			height: 43px;
			background-image: url("../../assets/ctcsv-oolio.png");
			background-repeat: no-repeat;
			background-size: contain;
			background-position: right;
			border-radius: 5px;
		}

		.option_link_impos {

			margin-left: auto;
			width: 222px;
			height: 43px;
			background-image: url("../../assets/ctcsv-impos.png");
			background-repeat: no-repeat;
			background-size: contain;
			background-position: right;
			border-radius: 5px;
		}

		.option_link_bepoz {

			margin-left: auto;
			width: 222px;
			height: 43px;
			background-image: url("../../assets/ctbepoz.png");
			background-repeat: no-repeat;
			background-size: contain;
			background-position: right;
			border-radius: 5px;
		}

		.option_link_swiftpos {
			margin-left: auto;
			width: 222px;
			height: 43px;
			background-image: url("../../assets/swiftpos-binding.png");
			background-repeat: no-repeat;
			background-size: contain;
			background-position: right;
			border-radius: 5px;
		}

		.option_unlink2r {
			margin-left: auto;
			width: 222px;
			// height: 43px;
			// background: url('../../../static/img/ctx2.png');
			text-align: right;
			background-repeat: no-repeat;
			background-size: contain;
			background-position: right;
		}

		.option_link2 {
			margin-left: auto;
			width: 222px;
			height: 43px;
			background: url('../../../static/img/cxt2.png');
			background-repeat: no-repeat;
			background-size: contain;
			background-position: right;
		}

		.option_link4 {
			margin-left: auto;
			width: 222px;
			height: 43px;
			background-image: url("../../assets/tanda.png");
			background-repeat: no-repeat;
			background-size: contain;
			background-position: right;
		}

		.option_link_eh {
			margin-left: auto;
			width: 222px;
			height: 43px;
			background-image: url("../../assets/imployment-hero-bind.png");
			background-repeat: no-repeat;
			background-size: contain;
			background-position: right;
		}	

		


		.option_link {
			margin-left: auto;
			height: 28px;
			font-size: 20px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: var(--text-color);
			line-height: 28px;
			text-decoration: underline;
			cursor: pointer;

			&::before {
				content: '';
				display: inline-block;
				width: 12px;
				height: 12px;
				background: #3BD578;
				border-radius: 6px;
				margin-right: 10px;
			}
		}

		.myset_icon {
			margin-left: auto;
			font-size: 22px;
			color: var(--text-color);
		}
	}
}

.fade-in-enter-active,
.fade-in-leave-active {
	transition: opacity .4s ease;
}

.fade-in-enter,
.fade-in-leave-to {
	opacity: 0;
}

.linkDio-tit {
	width: 100%;
	text-align: center;
	height: 33px;
	font-size: 24px;
	font-weight: 600;
	color: var(--text-color);
	line-height: 33px;
	margin-bottom: 20px;
}

.delMsg-tit {
	width: 100%;
	text-align: center;
	font-size: 24px;
	font-weight: 500;
	color: var(--text-color);
	line-height: 33px;
}

.success_icon {
	margin: 0 auto;
	width: 60px;
	height: 60px;
	background: url('../../../static/img/success.png');
	background-position: center;
	background-repeat: no-repeat;
	background-size: contain;
	margin-bottom: 40px;
}

.fail_icon {
	margin: 0 auto;
	width: 60px;
	height: 60px;
	background: url('../../../static/img/fail.png');
	background-position: center;
	background-repeat: no-repeat;
	background-size: contain;
	margin-bottom: 40px;
}

.newMessage {
	width: 100%;
	height: 28px;
	font-size: 20px;
	font-weight: 400;
	color: var(--text-color);
	line-height: 28px;
	margin: 10px 0 22px 0;
}

.newSelect {
	box-sizing: border-box;
	width: 100%;
	height: 50px;
	border-top: 1px solid var(--background-color-4);
	border-bottom: 1px solid var(--background-color-4);
	background: var(--background-color-2);
	line-height: 50px;
	font-size: 20px;
	font-weight: 400;
	color: var(--text-color);
	padding: 0 20px;
	display: flex;
	align-items: center;
	cursor: pointer;

	&:nth-child(2n) {
		border-top: none;
	}

	.myNewSel_icon {
		color: var(--text-color);
		font-size: 22px;
		margin-left: auto;
	}
}

.newLink-box {
	text-decoration: underline;
	cursor: pointer;
}

.nolink {
	color: var(--primary-color) !important;
}

.cardCanBtn2 {
	border: 2px solid var(--primary-color) !important;
	color: var(--primary-color) !important;
}

.link-to-btn {
	width: 90px;
	height: 40px;
	float: right;
	margin-top: 5px;
	font-size: 15px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: var(--text-color);
	line-height: 40px;
	text-align: right;
	text-decoration: underline;
	position: relative;
	cursor: pointer;
	margin-right: 10px;

	&::after {
		content: "";
		display: block;
		position: absolute;
		left: 0;
		top: 17px;
		width: 6px;
		height: 6px;
		background: #ea3796;
		border-radius: 50%;
	}
}


.periodic-container {
	@include montserrat-font(16px, normal, 500, $white) {
		margin-bottom: 20px;
	}

	.title {
		margin-bottom: 20px;
	}

	table {
		border: 1px solid #5F5F5F;

		&.email {
			td {
				&:nth-child(2) {
					width: 417px !important;
				}

				// &:nth-child(3) {
				// 	display: flex;
				// 	justify-content: center;
				// }

			}
		}

		td {
			padding: 10px 1rem;
			width: 184px;

			&:nth-child(1) {
				width: 52px;
				text-align: center;
			}

			&:nth-child(3) {
				text-align: center;
			}
		}

		td {
			border: 1px solid #5F5F5F;
		}
	}

	.el-button {
		@include montserrat-font(14px, normal, 700, $white) {
			padding: 0px 10px;
			height: 40px;
			display: flex;
			align-items: center;
			margin: auto;
		}

		&--primary {
			background-color: $blue;
		}

		&--danger {
			background-color: $red;
		}

		&--success {
			background-color: $green;
		}

		.el-icon-setting {
			&:before {
				font-size: 20px;
			}
		}

	}

	.footer {
		text-align: right;
		margin-top: 15px;

		span {
			font-weight: 700;
		}
	}

	.el-button--peiso-default {
		height: 55px;
		width: 172px;
	}


}

.tanda-anuation-container {
	.title {
		@include montserrat-font(24px, 36px, 400, $white);
	}

	.super-annuation-container {
		margin-top: 5rem;
		margin-bottom: 5rem;

		.annuation-wrapper {
			@include montserrat-font(18px, normal, 700, $white) {
				text-wrap: nowrap;
				max-width: 450px;
			}

			.peiso-input-default {
				width: 150px;
			}

		}
	}
}

.search-container {
	margin-bottom: 20px;
}

.venuelist-container-nodata {
	display: flex;
	justify-content: center;
	margin: 10px auto;
	h4 {
		color: var(--text-color);
		font-size: 15px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/setting/setting.vue